module.exports = __webpack_public_path__ + "img/hm.b5488f87.svg";